module.exports = __webpack_public_path__ + "static/media/heroes.80dd9dc7.png";